// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"2edeaf6b","413":"fd6af2cd","460":"8c633155","485":"f87a586f","490":"202fe04d","787":"a6fe6ae6","873":"9e8bc6ef"}[chunkId] + ".chunk.js";
};